import React, { Component } from 'react';

import { InputGroup, FormControl } from 'react-bootstrap';
import { withRouter } from "react-router";
import qs from 'qs';

import decodeDataUrl from '../utils/decodeDataUrl';

class URLPage extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            dataUrl: "",
            validationState : undefined,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (event) => {
        this.setState({ dataUrl: event.target.value });
    }

    updateURL = () => {
        let path = this.props.location.pathname;

        let query = qs.parse(this.props.location.search.replace("?",""));
        query.data = decodeDataUrl(this.state.dataUrl);

        let newURL = `${path}?${qs.stringify(query)}`;

        this.props.history.replace(newURL);
    }

    render() {
        return (
            <div className="search-page">
                {this.props.loading ?
                    <i className="fa fa-spinner fa-spin"></i>
                    :
                    <InputGroup style={{ width : 500}}>
                        <FormControl id="url" type="text" value={this.state.dataUrl} onChange={this.handleChange} placeholder="Enter URL to data file"/>
                        <InputGroup.Addon style={{width:50}} className="button noselect" onClick={this.updateURL}>Go</InputGroup.Addon>
                    </InputGroup>
                }
                <br/>
                {this.props.error && <span style={{color : "red", "textAlign": "center"}}>{this.props.error}</span>}
            </div>
        );
    }
}

export default withRouter(URLPage);
